export class PagoModel {
    public name: string;
    public lastName: string;
    public phoneNumber: string;
    public email: string;
    public idSocio: number;
    public idProducto: number;
    public producto: string;
    public tokenId: string;
    public amount: number;
    public description: string;
    public deviceSessionId: string;
    public result: string;

    constructor() { }
}